import m from "../../geodata/es2015/vaticanHigh";
window.am4geodata_vaticanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/vaticanHigh.js
// module id = null
// module chunks = 